import * as fflate from 'fflate';
import type { Zippable } from 'fflate';

import { type OoxmlPackage } from './ooxml';

export const buildXlsxPackage = (ooxmlPackage: OoxmlPackage): Blob => {
  const textEncoder = new TextEncoder();
  const files: Zippable = Object.fromEntries(
    ooxmlPackage.files.map(({ name, content }) => [
      name,
      textEncoder.encode(content),
    ]),
  );
  const zippedContent = fflate.zipSync(files, { level: 6 });

  return new Blob([new Uint8Array(zippedContent)], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });
};
